import gql from "graphql-tag";

export default gql`
  query getPassportFidelite {
    getPassportFidelite {
      id
      header_desktop
      header_mobile
      passportfidelite_attachment
      details {
        id
        email_content
        title
        description
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        language_code
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/passportfidelite/get.js